/**
 * draws dashed lines for min, max and avg
 * @param {Chart} chart - ChartJS instance
 * @param {boolean} hideLabel - defines wheather the line label text is supposed to show
 * @param {Chart} translations - text translations object
 */
export const drawLimitLines = (chart, hideLabel = false, translations, decimalPlaces = 3) => {
  if (!chart) return;

  const ctx = chart.ctx;
  const xaxis = chart.scales['x'];
  const yaxis = chart.scales['y'];

  if (!xaxis || !yaxis) return;

  // collect all Y values form all datasets
  const yValues = [];
  chart.data.datasets.map(dataset => {
    // dataset.data is either an array of objects (with x- and y-values) or an array of numbers (y-values)
    yValues.push(...(dataset.data.map(d => typeof d.y !== 'undefined' ? d.y : d)));
  });

  const limits = {
    min: {
      value: Math.min(...yValues),
      label: translations.min
    },
    max: {
      value: Math.max(...yValues),
      label: translations.max
    },
    avg: {
      value: yValues.reduce((sum, v) => sum += v, 0) / yValues.length,
      label: '\u00D8' // avg entity
    },
  };

  Object.values(limits).map((limit, i) => {
    // draw line label
    const y = yaxis.getPixelForValue(limit.value, undefined);
    ctx.fillStyle = '#000';
    ctx.font = 'normal bold 12px Arial';

    if (!hideLabel) {
      ctx.fillText(`${limit.label} ${limit.value.toFixed(decimalPlaces)}`, chart.ctx.canvas.width / window.devicePixelRatio - 20, y);
    }

    ctx.textBaseline = 'middle';
    ctx.textAlign = 'right';

    // draw line
    ctx.beginPath();
    ctx.moveTo(xaxis.left, Math.round(y) - 0.5);
    ctx.strokeStyle = '#000';
    ctx.setLineDash([3, 3]);
    ctx.lineTo(xaxis.right, Math.round(y) - 0.5);
    ctx.stroke();
    ctx.restore();
  });
};

/**
 * shows the tooltip for a specific index
 * @param {Chart} chart - ChartJS instance
 * @param {number} index - index of the point to show the tooltip for
 */
export const showTooltip = (chart, index) => {
  let mouseMoveEvent, meta, point, rectangle, value;

  meta = chart.getDatasetMeta(0);
  rectangle = chart.canvas.getBoundingClientRect();
  point = meta.data[index].getCenterPoint();

  mouseMoveEvent = new MouseEvent('mousemove', {
    clientX: rectangle.left + point.x,
    clientY: rectangle.top + point.y
  });

  chart.canvas.dispatchEvent(mouseMoveEvent);
};